// Accept only internal destinations and avoid returning to another error/login page.
export function getReturnPath(from) {
  const path = typeof from === 'string'
    ? from
    : from && `${from.pathname || ''}${from.search || ''}${from.hash || ''}`;
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//') ||
      /[\\\s]/.test(path) || Array.from(path).some(character => character.charCodeAt(0) < 32) ||
      /^\/(?:login|401|403|404)\/?(?:[?#]|$)/.test(path)) return '/';
  return path;
}
